var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaginationArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.041,
    height: 14.057,
    viewBox: "0 0 10.041 14.057",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-step-backward",
    "data-name": "Icon awesome-step-backward",
    d: "M4.5,15.93V2.626a.378.378,0,0,1,.377-.377H6.383a.378.378,0,0,1,.377.377V8.161l6.134-5.679a1,1,0,0,1,1.647.772V15.3a1,1,0,0,1-1.647.772L6.759,10.43v5.5a.378.378,0,0,1-.377.377H4.877A.378.378,0,0,1,4.5,15.93Z",
    transform: "translate(-4.5 -2.25)",
    fill: "#252829"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationArrow);
export default __webpack_public_path__ + "static/media/pagination-arrow.20398f0fafe20b59c70a9a9c85f39a51.svg";
export { ForwardRef as ReactComponent };